export const partnersSection = {
  title: 'Socis',
  description:
    `Ens esforcem per convertir-nos en líders treballant només amb socis fiables i de confiança amb un nom conegut. Cadascuna de les nostres seleccions es basa en alts estàndards de qualitat i professionalitat per proporcionar als nostres clients només el millor del món de la innovació. Creiem que només la cooperació mútuament beneficiosa i honesta amb els nostres socis l'ajudarà a convertir-se en el propietari de la casa dels seus somnis.`,
};
